module.exports = __webpack_public_path__ + "static/media/MEINM_MENU-normal.2b2ae6e6.png";